export default "__VITE_ASSET__HVLkH$zz__"